import { API } from "../api";
const BASE_URL = "/members/attendance";

const memberAttendanceExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberAttendanceSummary: builder.query({
      query: () => `${BASE_URL}/summary?guard=member`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: ["MemberAttendance"],
    }),
    getMemberAttendanceHistory: builder.query({
      query: ({ page = 1, limit = 20, status = "all", search = "", from_date = "", to_date = "" }) =>
        `${BASE_URL}/history?guard=member&page=${page}&limit=${limit}&status=${status}&search=${search}&from_date=${from_date}&to_date=${to_date}`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: ["MemberAttendance"],
    }),
    payAttendanceFine: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/pay-fine?guard=member`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["MemberAttendance"],
    }),
    payAttendanceFineBankTransfer: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/pay-fine-bank-transfer?guard=member`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["MemberAttendance", "member-bank-transfer-payments"],
    }),
  }),
});

export const {
  useGetMemberAttendanceSummaryQuery,
  useGetMemberAttendanceHistoryQuery,
  usePayAttendanceFineMutation,
  usePayAttendanceFineBankTransferMutation,
} = memberAttendanceExtendedApi;

